import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router preserves scroll position across client-side navigation and
 * ignores URL hashes. On every location change: scroll to the hash target
 * when one is present (after the new page has painted), otherwise to the top.
 */
const ScrollManager: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      // Wait a frame so the destination page has rendered its anchors
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'auto', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollManager;
